import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, intlShape, injectIntl } from "react-intl";
import { Row, Col, Nav, NavItem, Tab } from "react-bootstrap";

import DisabledOverlay from "../grundelemente/DisabledOverlay";

import ApplyDismiss from "./ApplyDismiss";
import BoolControl from "./BoolControl";
import EmailAccount from "./EmailAccount";
import EmailReceiver from "./EmailReceiver";
import { saveSettings } from "./SaveSettings";
import { isOk, stateFromModel, modelFromLocal, changeState, recheckState,
	validateDnsOrIp, validatePort, validateEmail } from "./SettingsValue";

import "./Email.css";

const receiverMessage = (index, intl) => {
	let pattern = intl.formatMessage({id: "{0} {1}"}, {
		"0": intl.formatMessage({id: "Receiver"}),
		"1": index + 1
	});
	return pattern;
};

/* NavItem muss direkt unter Nav stehen, oder die Sache mit dem Umschalten
 * der Tab-Inhalte funktioniert nicht mehr. Also muss React.createElement()
 * verwendet werden.
 */
const createReceiverNav = (i, intl) => (
	React.createElement(NavItem, {
		eventKey: "receiver" + i,
		key: i.toString()
	}, receiverMessage(i, intl))
);

const ReceiverPane = props => (
	<Tab.Pane eventKey={"receiver" + props.index} className="email-sub">
		<EmailReceiver receiver={props.receivers[props.index]}
			handleChange={props.handleChange} />
	</Tab.Pane>
);

ReceiverPane.propTypes = {
	index: PropTypes.number.isRequired,
	receivers: PropTypes.arrayOf(PropTypes.object).isRequired,
	handleChange: PropTypes.func.isRequired
};

const all_receivers = [0, 1, 2, 3, 4];

const default_local = {
	enabled: false,
	account: {
		smtp_server: null,
		smtp_port: null,
		user_name: null,
		user_password: null,
		sender_address: null,
		use_starttls: false
	},
	receivers: all_receivers.map(() => ({
		active: false,
		email_address: null,
		language: null,
		send_maintenance: false,
		send_warnings: false,
		send_errors: false,
		salutation: null,
		plant_address: null
	}))
};

class Email extends React.Component {

	static propTypes = {
		email: PropTypes.object.isRequired,
		intl: intlShape.isRequired,
		auth: PropTypes.object.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.handleChange = this.handleChange.bind(this);
		this.apply = this.apply.bind(this);
		this.dismiss = this.dismiss.bind(this);
		this.state = this.genState();
	}
	genState() { return stateFromModel(default_local, this.props.email, Email.validate); }
	apply() {
		let value = modelFromLocal(this.state.local);
		saveSettings("email", value);
	}
	dismiss() {
		this.setState(this.genState());
	}
	static validate(local) {
		if (!local.enabled.value) {
			return true;
		}
		if (!isOk(validateDnsOrIp(local.account, "smtp_server")) ||
			!isOk(validatePort(local.account, "smtp_port")) ||
			/* Benutzer Name und Passwort sind beide optional, mit Absicht.
			 * Es gibt sehr unterschiedliche SMTP-Server-Konfigurationen!
			 */
			!isOk(validateEmail(local.account, "sender_address", false))) {
			return false;
		}
		for (let receiver of local.receivers) {
			if (!receiver.active.value) {
				continue;
			}
			if (!isOk(validateEmail(receiver, "email_address"))) {
				return false;
			}
		}
		return true;
	}
	handleChange(e, prefix = "") {
		this.setState(changeState(prefix + e.target.name, e.target.value, this.state, Email.validate));
	}
	componentWillReceiveProps(nextProps) {
		let change = recheckState(this.state, nextProps.email, Email.validate);
		if (change) {
			this.setState(change);
		}
	}
	render() {
		return (
			<div className="Email">
				<DisabledOverlay disabled={!this.props.auth.canWrite} />
				<form>
					<BoolControl i18n_key="Email sending enabled" prop="enabled"
						local={this.state.local} handleChange={this.handleChange} />
				</form>
				<div>
					<Tab.Container defaultActiveKey="account" id="email_settings">
						<Row className="clearfix">
							<Col sm={4}>
								<Nav stacked>
									<NavItem eventKey="account">
										<FormattedMessage id="Account" />
									</NavItem>
									{all_receivers.map(i => createReceiverNav(i, this.props.intl))}
								</Nav>
							</Col>
							<Col sm={8}>
								<Tab.Content animation={false}>
									<Tab.Pane eventKey="account" className="email-sub">
										<EmailAccount account={this.state.local.account}
											handleChange={e => this.handleChange(e, "account.")} />
									</Tab.Pane>
									{all_receivers.map(i => <ReceiverPane key={i} index={i}
										receivers={this.state.local.receivers}
										handleChange={e => this.handleChange(e, "receivers." + i + ".")} />)}
								</Tab.Content>
							</Col>
						</Row>
					</Tab.Container>
				</div>
				<ApplyDismiss state={this.state} apply={this.apply} dismiss={this.dismiss} />
			</div>
		);
	}
}

export default injectIntl(Email);
